import { createSelector } from 'reselect'

import { initialState } from './reducers'
import { type IPayCardManagementState } from './types'

export const selectTabCount = (state: IPayCardManagementState) =>
  state.payCardManagement || initialState

export const makeSelectTabCount = () =>
  createSelector(
    [selectTabCount],
    (payCardManagementState) => payCardManagementState.tabCounts
  )

export const selectNewCardCreated = createSelector(
  selectTabCount,
  (payCardManagementState) => payCardManagementState.newCardCreated
)
